import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'

const MenuHistoryBackButton = ({ icon, onBack }) => {
  return (
    <Button
      icon={icon ? icon : <ArrowLeftOutlined />}
      onClick={() => {
        onBack()
      }}
    >
      Back
    </Button>
  )
}

MenuHistoryBackButton.propTypes = {
  icon: PropTypes.element,
  onBack: PropTypes.func.isRequired,
}

export default MenuHistoryBackButton
